import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationSectionComponent
} from './sections/location-of-devices-unrelated-to-road-occupation-section/location-of-devices-unrelated-to-road-occupation-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Inwestor',
  'Zajęcia',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../inwestor',
  cancelUrl: '../wnioskodawca',
  addRoadTrafficImpactControl: true,
  addManagerControls: true
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../dane-zajecia',
  customTitles: {
    sectionTitle: 'Inwestor',
    tag: 'investor',
    noDataInfo: 'Brak dodanych inwestorów!',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    dataSameAsApplicantLabels: {
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy',
      rejectLabel: 'Chcę wprowadzić dane inwestora'
    },
    cardTitle: 'Dodanie inwestora',
    cardTitle2: 'Edytuj inwestora'
  }
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../dane-zajecia',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const locationOfDevicesUnrelatedToRoadRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: contractorDataSectionConfig
  },
  {
    component: LocationOfDevicesUnrelatedToRoadOccupationSectionComponent,
    path: ':appId/dane-zajecia'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
